import { ArrowRight, MapPin, Phone, Clock, Mail } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import Seo from "@/components/Seo";
import { towns } from "@/data/services";

const FORM_PUBLIC_URL =
  "https://clienthub.getjobber.com/hubs/045a4e21-ad37-479b-9f5f-714a5888ee67/public/requests/2440620/new";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <Seo
        title="Request an Estimate, Legacy Scapes Ltd"
        description="Request an estimate from Legacy Scapes Ltd, serving Sarnia, Point Edward, Corunna, and the St. Clair Corridor."
      />

      <section className="bg-[#F4F6F3] pt-[76px]">
        <div className="mx-auto max-w-[1160px] px-5 py-16 md:px-8 md:py-20">
          <Reveal>
            <Eyebrow>Contact</Eyebrow>
            <h1 className="mt-4 max-w-2xl text-4xl font-extrabold leading-[1.08] tracking-tight text-[#16241C] sm:text-5xl" data-testid="contact-headline">
              Request an Estimate
            </h1>
            <p className="mt-4 max-w-xl text-base leading-[1.6] text-[#5B6B60]">
              Fill out the form and we'll get back to you within one business day. For
              commercial or property management inquiries, let us know in your message so we can
              route it to the right person.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-white">
        <div className="mx-auto max-w-[1160px] px-5 py-16 md:px-8 md:py-24">
          <Reveal>
            <div className="mx-auto max-w-[640px] rounded-2xl border border-[#043B1C]/15 bg-white p-10 text-center" data-testid="request-form-card">
              <h2 className="text-2xl font-extrabold tracking-tight text-[#16241C]">
                Tell us about your property
              </h2>
              <p className="mx-auto mt-3 max-w-md text-sm leading-[1.6] text-[#5B6B60]">
                The request form opens in a secure new tab, hosted by Jobber. It takes about a
                minute, and we respond within one business day.
              </p>
              <a
                href={FORM_PUBLIC_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="jobber-form-button"
                className="mt-7 inline-flex items-center gap-2 rounded-full bg-[#043B1C] px-10 py-4 text-sm font-bold text-white transition-colors duration-300 hover:bg-[#F4BE36] hover:text-[#043B1C]"
              >
                Request an Estimate
                <ArrowRight size={16} strokeWidth={2.5} />
              </a>
              <p className="mt-6 text-xs text-[#5B6B60]">
                Prefer to reach us directly? Email{" "}
                <a href="mailto:sales@legacyscapes.ca" className="font-bold text-[#043B1C]">sales@legacyscapes.ca</a>{" "}
                or call <a href="tel:+15193841824" className="font-bold text-[#043B1C]">(519) 384-1824</a>.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-10 grid gap-8 rounded-2xl bg-[#F4F6F3] p-8 sm:grid-cols-2 lg:grid-cols-4" data-testid="contact-details">
              <div>
                <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-[#043B1C]">
                  <Mail size={14} strokeWidth={2.5} /> Email us
                </p>
                <a href="mailto:sales@legacyscapes.ca" data-testid="contact-email-link" className="mt-2 block break-all text-base font-extrabold tracking-tight text-[#16241C]">
                  sales@legacyscapes.ca
                </a>
              </div>
              <div>
                <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-[#043B1C]">
                  <Phone size={14} strokeWidth={2.5} /> Phone
                </p>
                <a href="tel:+15193841824" data-testid="contact-phone-link" className="mt-2 block text-base font-extrabold tracking-tight text-[#16241C]">
                  (519) 384-1824
                </a>
              </div>
              <div>
                <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-[#043B1C]">
                  <Clock size={14} strokeWidth={2.5} /> Hours
                </p>
                <div className="mt-2 space-y-1 text-sm leading-[1.7] text-[#16241C]" data-testid="contact-hours-list">
                  <p>Mon – Thu, 8:00 AM – 6:00 PM</p>
                  <p>Fri, 8:00 AM – 5:00 PM</p>
                  <p>Sat, 8:00 AM – 11:00 AM</p>
                  <p>Sun, Closed</p>
                </div>
              </div>
              <div>
                <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-[#043B1C]">
                  <MapPin size={14} strokeWidth={2.5} /> Territory
                </p>
                <p className="mt-2 text-sm leading-[1.7] text-[#16241C]" data-testid="contact-territory">
                  Proudly serving {towns.join(", ")}, and the surrounding St. Clair Corridor.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
